module.exports = __webpack_public_path__ + "static/world-profile-3c9d2017056901760f67d1711ba114aa.pdf";